




import patientTemplate from "./templates/patientTemplate.vue";
export default {
  name: "aiwen-register-pc",
  components: {
    patientTemplate,
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        patient: "patientTemplate",
      };
      return businessTypeObj[(this as any).$attrs.config.businessType];
    },
  },
};
